import { OpenAPI } from '../services/api';

OpenAPI.BASE = process.env.REACT_APP_API_URL || '';
